SearchAutocomplete = {
	el:{}, 
	button:{},
	input:{},
	placeholder:{},
	icon:{},
	data:[],   

	init: function(){

		$.widget( "custom.catcomplete", $.ui.autocomplete, {
			_create: function() {
				this._super();
				this.widget().menu( "option", "items", "> :not(.ui-autocomplete-category)" );
			},
			_renderMenu: function( ul, items ) {
				var that = this,
			  	currentCategory = "";
				$.each( items, function( index, item ) {
				  var li;
				  if ( item.category != currentCategory ) {
				    ul.append( "<li class='ui-autocomplete-category'>" + item.category + "</li>" );
				    currentCategory = item.category;
				  }
				  li = that._renderItemData( ul, item );
				  if ( item.category ) {
				    li.attr( "aria-label", item.category + " : " + item.label );
				  }
				});
			}
		});

	    this.el = $('.sl-search-autocomplete');
			this.box = this.el.find('.sl-search-box');
			
			this.searchButton1 = $('#search-button-1'); // s this.box.find neslo :o
			this.searchButton2 = this.box.find('#search-button-2');
			this.searchButton3 = this.box.find('#search-button-3');
			this.searchButton4 = this.box.find('#search-button-4');

	    this.searchinput = this.box.find('.sl-search-input');
	    this.input = this.box.find('.sl-search-input');
	    this.placeholder = this.box.find('.sl-search-placeholder');
	    this.icon = $('.sl-search-show');

	    this.bind();
	},

	bind: function(){

		this.input.catcomplete({
	      delay: 0,
	      appendTo: $('.sl-search-box'),
	      source: function( request, response ) {
		    $.ajax({
		        url: WEB_ROOT+"/modules/search/autocomplete.php",
		        dataType: "json",
		        data: {term: request.term},
		        success: function(data) {
		            response($.map(data, function(item) {
		                return {
		                    label: item.label,
		                    category: item.category,
		                    url: item.url
		                };
		            }));
		        }
		    });
		},
		minlength:2,
	      select: function( event, ui ) {
	      		window.location.href = WEB_ROOT + "/" + ui.item.url;
			}
	    });

		this.input.focusin(function(event) {
			SearchAutocomplete.placeholder.addClass('hidden')
		});

		this.input.focusout(function(event) {
			if ($(this).val() == "")
				SearchAutocomplete.placeholder.removeClass('hidden');
		});

		this.el.find('.sl-search-input1').catcomplete({
	      delay: 0,
	      appendTo: $('.sl-search-box1'),
	      source: function( request, response ) {
		    $.ajax({
		        url: WEB_ROOT+"/modules/search/autocomplete.php",
		        dataType: "json",
		        data: {term: request.term},
		        success: function(data) {
		            response($.map(data, function(item) {
		                return {
		                    label: item.label,
		                    category: item.category,
		                    url: item.url
		                };
		            }));
		        }
		    });
		},
		minlength:2,
	      select: function( event, ui ) {
	      		window.location.href = WEB_ROOT + "/" + ui.item.url;
			}
	    });

		this.el.find('.sl-search-input1').focusin(function(event) {
			$('.sl-search-placeholder1').addClass('hidden')
		});

		this.el.find('.sl-search-input1').focusout(function(event) {
			if ($(this).val() == "")
				$('.sl-search-placeholder1').removeClass('hidden');
		});

		this.searchButton1.click(function () {
			console.log("AHOJ");
			$('#search-form-1').submit();
		});

		this.searchButton2.click(function() { 
			$('#search-form-2').submit();
		});

		this.searchButton3.click(function () {
			console.log("Baaa");
			$('#search-form-3').submit();
		});

		this.searchButton4.click(function () {
			$('#search-form-4').submit();
		});

		this.icon.click(function(event) {
			event.preventDefault();
			$(this).toggleClass('clicked');

			if (!$(this).is('.clicked'))
				SearchAutocomplete.hide();
			else 
				SearchAutocomplete.show();
		});
	},

	show: function(){
		this.el.addClass('visible');
		if (Menu.MainMenu.isVisible)
			Menu.MainMenu.hide();
	},

	hide: function(){
		this.el.removeClass('visible');
	},

	search: function(str){
		console.log(str)
		window.location.href = WEB_ROOT + "/vyhladavanie?s=" + str;
	},

	redirect: function(url){
		window.location.href = WEB_ROOT + "/" + url
	},

}